import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  LogoutIcon,
  PeopleIcon,
  VehicleIcon,
  QrIcon,
  AyristirmaIcon,
  Logo,
  DeleteIcon,
  NeighborhoodIcon,
  PersonelIcon,
  HouseIcon,
  SearchIcon,
  ReportIcon,
  CheckHouseIcon,
  BlockedHouseIcon,
} from '../../assets/icons';
import { useAuth } from '../../contexts/AuthContext';

const Layout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const isDetailPage = location.pathname.includes('detay');

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <div className="layout">
      <aside className={`sidebar ${isDetailPage ? 'icons-only' : ''}`}>
        <div className="logo-container">
          <Logo className="logo" />
        </div>

        <nav className="nav-menu">
          <NavLink to="/summary" className="nav-item">
            {({ isActive }) => (
              <>
                <HouseIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Özet</span>}
              </>
            )}
          </NavLink>
          {/* <NavLink to="/dashboard" className="nav-item">
            {({ isActive }) => (
              <>
                <QrIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>QR Kod</span>}
              </>
            )}
          </NavLink> */}
          <NavLink to="/him-kayit-sorgulama" className="nav-item">
            {({ isActive }) => (
              <>
                <SearchIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>HIM Kayıt Sorgulama</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/raporlama" className="nav-item">
            {({ isActive }) => (
              <>
                <ReportIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Raporlama<br/>(ORANLI)</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/mahalle-analizi" className="nav-item">
            {({ isActive }) => (
              <>
                <NeighborhoodIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Mahalle Analizi</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/gunluk-is-takip" className="nav-item">
            {({ isActive }) => (
              <>
                <PersonelIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Günlük İş Takip</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/kisiler" className="nav-item">
            {({ isActive }) => (
              <>
                <PeopleIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Kişiler</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/adresatamalari" className="nav-item">
            {({ isActive }) => (
              <>
                <PersonelIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Görev Planlama</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/gorevler" className="nav-item">
            {({ isActive }) => (
              <>
                <PersonelIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Saha Çizelgesi</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/wastepool" className="nav-item">
            {({ isActive }) => (
              <>
                <PeopleIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Atık Havuzu</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/atik-verisi" className="nav-item">
            {({ isActive }) => (
              <>
                <DeleteIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Atık Verisi</span>}
              </>
            )}
          </NavLink>

          <NavLink to="/ayristirma" className="nav-item">
            {({ isActive }) => (
              <>
                <AyristirmaIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Ayrıştırma</span>}
              </>
            )}
          </NavLink>

          <NavLink to="/vasita" className="nav-item hidden">
            {({ isActive }) => (
              <>
                <VehicleIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Vasıta</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/personel" className="nav-item">
            {({ isActive }) => (
              <>
                <PersonelIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Personel</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/mahalle" className="nav-item">
            {({ isActive }) => (
              <>
                <NeighborhoodIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Mahalle</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/qr-kontrol" className="nav-item">
            {({ isActive }) => (
              <>
                <QrIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>QR Kontrol</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/gruplar" className="nav-item">
            {({ isActive }) => (
              <>
                <PersonelIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Gruplar</span>}
              </>
            )}
          </NavLink> 
     
          <NavLink to="/talepler" className="nav-item">
            {({ isActive }) => (
              <>
                <PersonelIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Vatandaş - Talepler</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/talep-kategorileri" className="nav-item">
            {({ isActive }) => (
              <>
                <PersonelIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Vatandaş - Talep Kategorileri</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/engellenen-adresler" className="nav-item">
            {({ isActive }) => (
              <>
                <BlockedHouseIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Engellenen Adresler</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/Ayarlar" className="nav-item">
            {({ isActive }) => (
              <>
                <PersonelIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Vatandaş - Ayarlar</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/sss" className="nav-item">
            {({ isActive }) => (
              <>
                <PersonelIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Vatandaş - Sss</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/popup" className="nav-item">
            {({ isActive }) => (
              <>
                <PersonelIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Vatandaş - Popup</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/adresler" className="nav-item">
            {({ isActive }) => (
              <>
                <CheckHouseIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Adresler</span>}
              </>
            )}
          </NavLink>
          <NavLink to="/bildirimler" className="nav-item">
            {({ isActive }) => (
              <>
                <PersonelIcon color={isActive ? '#FFFFFF' : '#18964E'} className="nav-icon" />
                {!isDetailPage && <span>Vatandaş - Bildirimler</span>}
              </>
            )}
          </NavLink>
          <button
            onClick={handleLogout}
            className="logout-button"
            disabled={isLoggingOut}
          >
            {!isDetailPage && <span>Çıkış Yap</span>}
            <LogoutIcon className="nav-icon" />
          </button>
          <a href="https://www.izmirteknoloji.com.tr/tr/" target="_blank" rel="noopener noreferrer">
            <img width={135} src="iztek-logo.svg" alt="izmirteknoloji" />
          </a>
        </nav>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout; 